import React from 'react';
import CreatableSelect from 'react-select/creatable'
import '../../assets/css/components/select-or-create.css';

const SelectOrCreate = props => {
  const { selectProps, placeholder, error, hidden, input, label, name, type, wrapperClass, validate } = props

  const styles = {
    option: (provided, state) => ({ ...provided }),
    control: provided =>Object.assign(provided, {
      border: 'none',
      borderColor: 'white',
      maxHeight: '25px',
      minHeight: '25px',
      boxShadow: 'none !important',
      '&:hover': {
        border: 'none !important',
        boxShadow: 'none !important'
      }
    }),
    valueContainer: provided => Object.assign(provided, {
      marginTop: '-5px',
      padding: '0'
    }),
    a11yText: {
      border: 'none'
    },
    indicatorsContainer: provided => Object.assign(provided, {
      marginTop: '-4px'
    })
  }

  // This method returns the same props that react-form passes down, but
  // modifies the onChange function to play nice with react-select's
  // Creatable value format.
  //
  // react-form expects `onChange(e)` where e is an event such that it calls
  // `e.target.value`. React-select does not seem to use an event for its onChange
  // and instead directly passes the new value which should be an object with a value
  // and label. The new onChange simulates giving the `e` event to react-form.
  const reactFormProps = ()=> {
    const { onChange, ...rest } = input
    return {
      onChange: (newVal, meta)=>input.onChange({ target: { value: newVal }}),
      ...rest
    }
  }

  return(
    <div className={`select-or-create ${type || 'text'} ${wrapperClass || ''} input form-group form-group-default`}>
      {label && <label>{label}</label>}
      <CreatableSelect
        className='select form-control no-box-shadow'
        id={name}
        {...reactFormProps()}
        {...selectProps}
        type={type || 'text'}
        placeholder={placeholder}
        styles={styles}
      />
      {error && <span className='error'>{error}</span>}
    </div>
  )
}

export default SelectOrCreate
